import { meta } from './meta';
import type { ChatSettings } from './types';
import { ChatsProvider } from './types';
import { defaults as allInOneChatDefaults } from './widgets-defaults/all-in-one-chat.defaults';
import { defaults as discordChatDefaults } from './widgets-defaults/discord-chat.default';
import { defaults as facebookChatDefaults } from './widgets-defaults/facebook-chat.defaults';
import { defaults as instagramChatDefaults } from './widgets-defaults/instagram-chat.defaults';
import { defaults as lineChatDefaults } from './widgets-defaults/line-chat.defaults';
import { defaults as telegramChatDefaults } from './widgets-defaults/telegram-chat.defaults';
import { defaults as viberChatDefaults } from './widgets-defaults/viber-chat.defaults';
import { defaults as whatsappChatDefaults } from './widgets-defaults/whatsapp-chat.defaults';

/*
  All of these settings will be used as widget settings and saved by default
  Configurator also use these settings as controls defaults
 */

const { provider } = meta;

const standaloneDefaults: Record<
  Partial<ChatsProvider>,
  Partial<ChatSettings>
> = {
  [ChatsProvider.all]: allInOneChatDefaults,
  [ChatsProvider.whatsapp]: whatsappChatDefaults,
  [ChatsProvider.telegram]: telegramChatDefaults,
  [ChatsProvider.instagram]: instagramChatDefaults,
  [ChatsProvider.viber]: viberChatDefaults,
  [ChatsProvider.line]: lineChatDefaults,
  [ChatsProvider.discord]: discordChatDefaults,
  [ChatsProvider.facebook]: facebookChatDefaults
};

export const defaultSettings: Partial<ChatSettings> = {
  name: 'John Doe',
  nameCaptionType: 'replyTime',
  nameCaptionReplyTime: 'Typically replies within a day',
  nameCaptionCustom: '',
  align: 'left',
  bubbleText: '',
  welcomeMessage:
    "Did you know that this widget can help you provide support, consult customers, do sales, collect feedback and build customer relationships?<br><br>Drop me a line, and I'll tell you how 🤩",
  buttonIconVisible: true,
  position: 'floating',
  whereToDisplayChat: 'allPages',
  excludedPages: [],
  specificPages: [],
  timeOnPage: 0,
  scrollPosition: 0,
  onPageLoad: false,
  displayDays: [0, 1, 2, 3, 4, 5, 6],
  timeSchedule: false,
  displayStartTime: {
    type: 'time',
    time: '09:00'
  },
  displayEndTime: {
    type: 'time',
    time: '17:00'
  },
  rememberVisitor: 1,
  buttonText: 'Start Chat',
  windowWidth: '360px',
  devicesToDisplay: ['mobile', 'desktop'],
  showChatTo: 'allVisitors',
  timeOnSite: 0,
  notifications: ['bubbleBadge'],
  buttonBorderRadius: 4,
  bubbleAnimationInterval: 10,
  bubbleAnimationEnabled: true,
  messageBackgroundColor: 'rgb(239, 239, 239)',
  chatWallpaper: 'rgb(255, 255, 255)',
  bubbleBackgroundColor: 'rgb(255, 255, 255)',
  bubbleIconColor: 'rgb(0, 132, 255)',
  headerBackgroundColor: 'rgb(250, 250, 250)',
  notificationBadgeColor: 'rgb(255, 0, 0)',
  userOnlinePoint: 'rgb(74, 213, 4)',
  customCSS: '',
  customJS: '',
  floatingVerticalOffset: 20,
  floatingHorizontalOffset: 20,
  googleAnalytics: [],

  ...(standaloneDefaults[provider] ?? allInOneChatDefaults)
};
